import React, { useCallback, useEffect, useMemo, useState } from "react";

import Drawer from "devextreme-react/drawer";
import config from "devextreme/core/config";

import { MainDrawerContent } from "@app/components";
// import { InsiderDrawerContent } from '@app/components/drawer/InsiderDrawer';
import { MENU_WIDTH } from "@app/components/drawer_sfx/background";
import { InsiderDrawerContent as InsiderDrawerContentSfx } from "@app/components/drawer_sfx/InsiderDrawer";
import {
  AllotmentProvider,
  Case,
  CaseElse,
  ComponentStackProvider,
  GatherPdfData,
  Switch,
  useReverseRoute,
} from "@app/contexts";
import {
  Download,
  IndividualHome,
  Page404,
  Profile,
  ShowCase,
} from "@app/pages";
import {
  checkSession,
  selectCurrentUiDrawerPage,
  setUiDrawer,
  useAppDispatch,
  useAppSelector,
} from "@app/state";
import * as appConst from "@app/state/constants";

import { InsiderGate } from "../../contexts/insiderGate";
import { licenseKey } from "../../devextreme-license";
import {
  ExchangeRates,
  SuperAdminGroups,
  SuperAdminHome,
  SuperAdminShowCase,
  SuperAdminUsers,
  SwsBuilder,
  WhatsNew,
} from "../superadmin";

config({ licenseKey });

export const AuthRoutes = () => {
  const dispatch = useAppDispatch();
  const theCurrentDrawerPage = useAppSelector(selectCurrentUiDrawerPage);
  const [drawerOpened, setDrawerOpened] = useState(false);
  const { routeInit } = useReverseRoute("AuthRoutes");
  // const { jgDrawerHeight } = useWindowDimensions();
  const toggleDrawer = useCallback(
    (bool?: boolean) => {
      if (typeof bool === "boolean") {
        setDrawerOpened(bool);
        return;
      }
      setDrawerOpened((p) => !p);
    },
    [drawerOpened]
  );

  const isInsiderMode = useMemo(
    () => theCurrentDrawerPage === appConst.DRAWER_PAGES.INSIDERS,
    [theCurrentDrawerPage]
  );

  const isInsiderMode_ = true;

  useEffect(() => {
    dispatch(checkSession());
    if (isInsiderMode) {
      setDrawerOpened(true);
    }
  }, []);

  return (
    <div className={`authenticated ${isInsiderMode ? "insider" : ""}`}>
      <div ref={routeInit}></div>
      <Drawer
        id="jgap-drawer"
        className={`jgap-drawer-${isInsiderMode ? "insider" : "main"}`}
        style={{ display: "block", height: "100%" }}
        height="100%"
        opened={drawerOpened}
        openedStateMode={"push"}
        revealMode={"slide"}
        // height={jgDrawerHeight}
        render={() => (
          <Switch value={isInsiderMode}>
            <Case when={true}>
              <InsiderGate
                childName="InsiderDrawerContent"
                toggleDrawer={toggleDrawer}
              >
                <ComponentStackProvider>
                  <AllotmentProvider>
                    <InsiderDrawerContentSfx />
                  </AllotmentProvider>
                </ComponentStackProvider>
              </InsiderGate>
            </Case>
            <CaseElse>
              <MainDrawerContent
                toggleDrawer={toggleDrawer}
                currentPage={theCurrentDrawerPage}
              />
            </CaseElse>
          </Switch>
        )}
        closeOnOutsideClick={false}
        maxSize={isInsiderMode ? MENU_WIDTH : 66}
        minSize={66}
      >
        <div className="important-wrapper" style={{ paddingLeft: "1px" }}>
          <Switch value={theCurrentDrawerPage}>
            <Case when={appConst.DRAWER_PAGES.DOWNLOAD}>
              <Download />
            </Case>
            <Case when={appConst.DRAWER_PAGES.PROFILE}>
              <Profile />
            </Case>
            <Case when={appConst.DRAWER_PAGES.SHOWCASE}>
              <ShowCase />
            </Case>
            <Case when={appConst.DRAWER_PAGES.SWSADMIN}>
              <SuperAdminHome />
            </Case>
            <Case when={appConst.DRAWER_PAGES.SWSADMIN_USERS}>
              <SuperAdminUsers />
            </Case>
            <Case when={appConst.DRAWER_PAGES.SWSADMIN_GROUPS}>
              <SuperAdminGroups />
            </Case>
            <Case when={appConst.DRAWER_PAGES.SWSADMIN_SHOWCASE}>
              <SuperAdminShowCase />
            </Case>
            <Case when={appConst.DRAWER_PAGES.SWSADMIN_EXRATES}>
              <ExchangeRates />
            </Case>
            <Case when={appConst.DRAWER_PAGES.SWSBUILDER}>
              <RedirectToGroups />
            </Case>
            <Case when={appConst.DRAWER_PAGES.WHATSNEW}>
              <WhatsNew />
            </Case>
            <Case when={appConst.DRAWER_PAGES.INSIDERS}>
              <InsiderGate
                childName={appConst.DRAWER_PAGES.INSIDERS}
                toggleDrawer={toggleDrawer}
              >
                <ComponentStackProvider>
                  <AllotmentProvider>
                    <GatherPdfData>
                      <IndividualHome />
                    </GatherPdfData>
                  </AllotmentProvider>
                </ComponentStackProvider>
              </InsiderGate>
            </Case>
            <CaseElse>
              <Page404 />
            </CaseElse>
          </Switch>
        </div>
      </Drawer>
    </div>
  );
};

const RedirectToGroups = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setUiDrawer({ currentPage: appConst.DRAWER_PAGES.SWSADMIN_GROUPS }));
  }, [dispatch]);
  return (
    <div style={{ padding: "40px", fontSize: "16px", color: "#64748b" }}>
      Această pagină a fost mutată sub arborele OrgMan. Redirecţionare...
    </div>
  );
};
